export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  tags: string[];
  description: string;
  chapters: ComicChapter[];
  rating: number;
  views: number;
  status: string;
  updatedAt: string;
}

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'secret-romance',
    title: '秘密恋爱守则',
    author: '金智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20romance%20couple%20embracing%20soft%20warm%20lighting%20pastel%20pink%20background%20simple%20clean%20composition%20emotional%20tender%20moment%20beautiful%20character%20design%20webtoon%20art%20style%20vertical%20format&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['甜宠', '校园', '治愈'],
    description: '平凡的大学生李恩在偶然的机会下与校园男神朴智勋开启了秘密恋爱。两人小心翼翼地守护着这份感情，却不知周围早已暗流涌动。当秘密被揭开，他们的爱情能否经得起考验？一段甜蜜又心酸的校园恋爱故事。',
    chapters: [
      { id: 'c1-1', title: '第1话 偶然的相遇', number: 1, updatedAt: '2026-07-05' },
      { id: 'c1-2', title: '第2话 心跳加速', number: 2, updatedAt: '2026-07-04' },
      { id: 'c1-3', title: '第3话 秘密的约定', number: 3, updatedAt: '2026-07-01' },
      { id: 'c1-4', title: '第4话 校园里的目光', number: 4, updatedAt: '2026-06-28' },
      { id: 'c1-5', title: '第5话 无法言说的心意', number: 5, updatedAt: '2026-06-25' },
    ],
    rating: 4.8,
    views: 1285000,
    status: '连载中',
    updatedAt: '2026-07-05',
  },
  {
    id: '2',
    slug: 'blade-of-destiny',
    title: '命运之刃',
    author: '朴志浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20warrior%20holding%20sword%20dramatic%20lighting%20dark%20epic%20background%20flame%20and%20shadow%20powerful%20character%20pose%20webtoon%20art%20style%20vertical%20format%20simple%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['热血', '冒险', '转生'],
    description: '被命运选中的少年剑士金泰浩，在魔族入侵的乱世中踏上复仇之路。手持传说中的命运之刃，他必须在光明与黑暗之间做出抉择。宏大的世界观，酣畅淋漓的战斗场面，一部不容错过的奇幻史诗。',
    chapters: [
      { id: 'c2-1', title: '第1话 觉醒之日', number: 1, updatedAt: '2026-07-06' },
      { id: 'c2-2', title: '第2话 剑与誓言', number: 2, updatedAt: '2026-07-03' },
      { id: 'c2-3', title: '第3话 试炼之路', number: 3, updatedAt: '2026-06-30' },
    ],
    rating: 4.9,
    views: 2150000,
    status: '连载中',
    updatedAt: '2026-07-06',
  },
  {
    id: '3',
    slug: 'office-chemistry',
    title: '办公室化学反应',
    author: '崔秀英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20stylish%20couple%20in%20modern%20office%20setting%20professional%20attire%20elegant%20warm%20tone%20minimalist%20background%20webtoon%20art%20style%20vertical%20format%20clean%20composition%20mature%20characters&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['职场', '成人', '都市'],
    description: '冷面上司与热血新人的办公室恋爱攻防战！姜代表以冷酷无情著称，直到碰上了天不怕地不怕的新人林小鹿。一场火花四溅的办公室化学反应就此展开——谁说职场不能有爱情？',
    chapters: [
      { id: 'c3-1', title: '第1话 新人的第一天', number: 1, updatedAt: '2026-07-04' },
      { id: 'c3-2', title: '第2话 意外的加班', number: 2, updatedAt: '2026-07-01' },
    ],
    rating: 4.7,
    views: 960000,
    status: '连载中',
    updatedAt: '2026-07-04',
  },
  {
    id: '4',
    slug: 'phantom-detective',
    title: '幽灵侦探',
    author: '李贤宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20detective%20in%20trench%20coat%20dark%20rainy%20alley%20noir%20atmosphere%20moody%20lighting%20suspenseful%20webtoon%20art%20style%20vertical%20format%20simple%20composition%20dramatic%20shadows&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['推理', '超自然', '犯罪'],
    description: '拥有看见鬼魂能力的刑警韩东秀，与搭档幽灵侦探一起破解悬案。每一桩案件背后都隐藏着人性的黑暗与救赎。烧脑的推理加上超自然的设定，带给你前所未有的悬疑体验。',
    chapters: [
      { id: 'c4-1', title: '第1话 看不见的目击者', number: 1, updatedAt: '2026-07-02' },
      { id: 'c4-2', title: '第2话 死者的话语', number: 2, updatedAt: '2026-06-28' },
      { id: 'c4-3', title: '第3话 红色房间', number: 3, updatedAt: '2026-06-24' },
      { id: 'c4-4', title: '第4话 真相的边缘', number: 4, updatedAt: '2026-06-20' },
    ],
    rating: 4.6,
    views: 789000,
    status: '连载中',
    updatedAt: '2026-07-02',
  },
  {
    id: '5',
    slug: 'cat-cafe-diary',
    title: '猫咪咖啡馆日记',
    author: '郑多惠',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cute%20cats%20in%20cozy%20cafe%20setting%20warm%20sunlight%20healing%20atmosphere%20soft%20pastel%20colors%20wholesome%20webtoon%20art%20style%20vertical%20format%20simple%20composition%20calm%20vibes&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '日常',
    categorySlug: 'slice-of-life',
    tags: ['治愈', '萌宠', '美食'],
    description: '辞去高压工作的允儿接手了一家老旧的猫咪咖啡馆。在这里，她遇到了形形色色的客人和性格各异的猫咪。每一杯咖啡，每一只猫咪，都在治愈着都市人疲惫的心灵。',
    chapters: [
      { id: 'c5-1', title: '第1话 邂逅猫之日', number: 1, updatedAt: '2026-07-07' },
      { id: 'c5-2', title: '第2话 橘猫胖胖', number: 2, updatedAt: '2026-07-05' },
      { id: 'c5-3', title: '第3话 第一位客人', number: 3, updatedAt: '2026-07-02' },
    ],
    rating: 4.9,
    views: 1560000,
    status: '连载中',
    updatedAt: '2026-07-07',
  },
  {
    id: '6',
    slug: 'dragon-academy',
    title: '龙之学院',
    author: '吴成民',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20magic%20academy%20students%20casting%20spells%20magnificent%20castle%20background%20glowing%20magic%20effects%20adventure%20webtoon%20art%20style%20vertical%20format%20dynamic%20composition%20youthful%20energy&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['魔法', '学院', '成长'],
    description: '被龙之学院破格录取的平民少年郑贤宇，在这所精英云集的魔法学院中步步为营。没有贵族背景的他，凭借过人的天赋和不懈的努力，誓要成为最强龙骑士！',
    chapters: [
      { id: 'c6-1', title: '第1话 入学通知书', number: 1, updatedAt: '2026-07-06' },
      { id: 'c6-2', title: '第2话 龙之契约', number: 2, updatedAt: '2026-07-03' },
      { id: 'c6-3', title: '第3话 第一堂课', number: 3, updatedAt: '2026-06-29' },
    ],
    rating: 4.7,
    views: 1890000,
    status: '连载中',
    updatedAt: '2026-07-06',
  },
  {
    id: '7',
    slug: 'love-in-bloom',
    title: '花开时节遇见你',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20spring%20cherry%20blossom%20beautiful%20couple%20under%20blooming%20trees%20soft%20pink%20atmosphere%20gentle%20sunlight%20romantic%20webtoon%20art%20style%20vertical%20format%20dreamy%20composition%20youthful%20love&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['青春', '治愈', '初恋'],
    description: '樱花盛开的季节，转学生尹夏恩遇见了坐在樱花树下的神秘少年。一场关于青春、梦想与初恋的故事就此展开。时光荏苒，那年花开时节的心动，是否还能再次绽放？',
    chapters: [
      { id: 'c7-1', title: '第1话 樱花树下的你', number: 1, updatedAt: '2026-07-05' },
      { id: 'c7-2', title: '第2话 午后的图书馆', number: 2, updatedAt: '2026-07-02' },
      { id: 'c7-3', title: '第3话 运动会的心跳', number: 3, updatedAt: '2026-06-28' },
      { id: 'c7-4', title: '第4话 雨天的约定', number: 4, updatedAt: '2026-06-24' },
    ],
    rating: 4.8,
    views: 1100000,
    status: '连载中',
    updatedAt: '2026-07-05',
  },
  {
    id: '8',
    slug: 'night-hunters',
    title: '暗夜猎手',
    author: '赵允浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20thriller%20hunter%20with%20weapons%20urban%20night%20cityscape%20neon%20lights%20dynamic%20action%20pose%20dark%20atmosphere%20webtoon%20art%20style%20vertical%20format%20cinematic%20composition%20intense%20mood&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    tags: ['都市', '异能', '战斗'],
    description: '在首尔的夜色之下，隐藏着一个由异能者组成的地下世界。退役特种兵姜赫在意外获得异能后，被卷入一场跨越百年的宿命之战。枪火与异能交织的暗夜猎杀，就此拉开帷幕。',
    chapters: [
      { id: 'c8-1', title: '第1话 夜之觉醒', number: 1, updatedAt: '2026-07-06' },
      { id: 'c8-2', title: '第2话 地下世界', number: 2, updatedAt: '2026-07-03' },
      { id: 'c8-3', title: '第3话 猎人的规则', number: 3, updatedAt: '2026-06-29' },
      { id: 'c8-4', title: '第4话 第一场狩猎', number: 4, updatedAt: '2026-06-25' },
    ],
    rating: 4.6,
    views: 1340000,
    status: '连载中',
    updatedAt: '2026-07-06',
  },
  {
    id: '9',
    slug: 'moonlight-garden',
    title: '月光庭园',
    author: '尹秀雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20mystical%20garden%20under%20moonlight%20elegant%20characters%20in%20traditional-inspired%20clothing%20ethereal%20glowing%20atmosphere%20beautiful%20webtoon%20art%20style%20vertical%20format%20dreamy%20composition%20magical%20vibes&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['宫廷', '轮回', '浪漫'],
    description: '千年月光庭园中，守护灵与人类少女的跨时空之恋。每一轮月圆之夜，庭园中的回忆便会重现。她能否找回前世的记忆，与命定之人再度相遇？唯美画风，感人至深的奇幻爱情。',
    chapters: [
      { id: 'c9-1', title: '第1话 庭园的访客', number: 1, updatedAt: '2026-07-04' },
      { id: 'c9-2', title: '第2话 月光下的约定', number: 2, updatedAt: '2026-06-30' },
    ],
    rating: 4.9,
    views: 2010000,
    status: '连载中',
    updatedAt: '2026-07-04',
  },
  {
    id: '10',
    slug: 'food-truck-dream',
    title: '餐车梦想家',
    author: '金敏珠',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20food%20cooking%20cozy%20food%20truck%20at%20night%20market%20warm%20lights%20delicious%20food%20steaming%20atmosphere%20healing%20slice%20of%20life%20webtoon%20art%20style%20vertical%20format%20wholesome%20composition%20inviting%20vibes&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '日常',
    categorySlug: 'slice-of-life',
    tags: ['美食', '创业', '励志'],
    description: '被公司裁员的料理师金大浩，用遣散费买了一辆二手餐车，开始了街头美食之旅。从无人问津到排起长队，他用一道道暖心料理征服了食客的胃和心。美食与梦想，都不可辜负。',
    chapters: [
      { id: 'c10-1', title: '第1话 被裁员的料理师', number: 1, updatedAt: '2026-07-05' },
      { id: 'c10-2', title: '第2话 第一辆餐车', number: 2, updatedAt: '2026-07-01' },
      { id: 'c10-3', title: '第3话 深夜的客人', number: 3, updatedAt: '2026-06-27' },
    ],
    rating: 4.8,
    views: 870000,
    status: '连载中',
    updatedAt: '2026-07-05',
  },
  {
    id: '11',
    slug: 'death-game',
    title: '死亡游戏',
    author: '郑泰元',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20psychological%20thriller%20dark%20game%20setting%20tense%20characters%20facing%20each%20other%20ominous%20red%20lighting%20suspenseful%20atmosphere%20webtoon%20art%20style%20vertical%20format%20intense%20composition%20survival%20theme&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['生存', '心理', '惊悚'],
    description: '十名陌生人被困在一栋封闭建筑中，被迫参加一场死亡游戏。每一轮投票将淘汰一人——被淘汰者的命运是真实的死亡。信任与背叛，人性在极端环境下的真实面目，谁能活到最后？',
    chapters: [
      { id: 'c11-1', title: '第1话 醒来', number: 1, updatedAt: '2026-07-07' },
      { id: 'c11-2', title: '第2话 规则', number: 2, updatedAt: '2026-07-04' },
      { id: 'c11-3', title: '第3话 第一轮投票', number: 3, updatedAt: '2026-07-01' },
    ],
    rating: 4.5,
    views: 1650000,
    status: '连载中',
    updatedAt: '2026-07-07',
  },
  {
    id: '12',
    slug: 'martial-arts-legend',
    title: '武林传奇',
    author: '宋振宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20warrior%20in%20traditional%20clothing%20dynamic%20fighting%20pose%20ancient%20asian%20landscape%20background%20ink%20wash%20painting%20style%20epic%20webtoon%20art%20style%20vertical%20format%20powerful%20composition%20heroic%20vibes&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    tags: ['武侠', '复仇', '成长'],
    description: '灭门之仇，十年磨一剑。少年张云龙隐姓埋名拜入武林名门，从最低阶的外门弟子做起，一步步踏上复仇之路。江湖恩怨、儿女情长，一部荡气回肠的武侠巨作。',
    chapters: [
      { id: 'c12-1', title: '第1话 灭门之夜', number: 1, updatedAt: '2026-07-06' },
      { id: 'c12-2', title: '第2话 拜师学艺', number: 2, updatedAt: '2026-07-02' },
      { id: 'c12-3', title: '第3话 初入江湖', number: 3, updatedAt: '2026-06-28' },
      { id: 'c12-4', title: '第4话 比武大会', number: 4, updatedAt: '2026-06-23' },
      { id: 'c12-5', title: '第5话 血战群雄', number: 5, updatedAt: '2026-06-18' },
    ],
    rating: 4.7,
    views: 1780000,
    status: '连载中',
    updatedAt: '2026-07-06',
  },
];

export const getComicBySlug = (slug: string): Comic | undefined => {
  return comics.find((c) => c.slug === slug);
};

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  return comics.filter((c) => c.categorySlug === categorySlug);
};

export const getFeaturedComics = (): Comic[] => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, 8);
};

export const getLatestComics = (): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8);
};

export const getPopularComics = (): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, 8);
};